import { render } from "./persetujuan.vue?vue&type=template&id=32efe837"
import script from "./persetujuan.vue?vue&type=script&lang=js"
export * from "./persetujuan.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./persetujuan.vue?vue&type=style&index=0&id=32efe837&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/mymac/Documents/Digitala/Pulih_Anita/frontend-pulih/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__